<template>
  <div>
    <b-form-file
      v-model="model"
      
      placeholder="Selecione un archivo"
      browse-text="Anexar"
      drop-placeholder="Suelte los archivos aqui...."
      size='md'
      :accept="accept"
      :multiple="multiple"
      @input="onSelecte()"
    >
      <template slot="file-name" slot-scope="{ names }">
     <b-badge v-if="names.length > 0" variant="dark" class="ml-1">
       + {{ names.length }} Archivo(s) seleccionado(s)
     </b-badge>
   </template>
   
    </b-form-file>
  </div>
</template>

<script>
export default {
  name: "FileInput",
  data() {
    return {
      model:[]
    };
  },
  props: {
    accept:{ type: String, default: ''},
    multiple:{ type: Boolean, default: false },
  },
  methods: {
    onSelecte() {
      this.$emit("filesSel", this.model);
    }
  }
};
</script>

